module.exports = "#add-zone {\r\n    max-width: 400px;\r\n    margin: 20px auto;\r\n}\r\n\r\n.txt_link a {\r\n    color: #81868a;\r\n    font-size: 2em;\r\n    padding: 2px 6px 17px;\r\n    float: right;\r\n    text-decoration: none;\r\n}\r\n\r\n.lang-c {\r\n    display: block;\r\n    float: right;\r\n}\r\n\r\n.pointer {\r\n    cursor: pointer;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = main